<div
  id="form-add-documents"
  tabindex="-1"
  role="dialog"
  class="modal fade modal-colored-header"
>
  <div class="modal-dialog custom-width documents-modal-dialog">
    <div class="modal-content">
      <div class="documents-modal-header">
        <div class="panel-heading panel-heading-flex">
          <h3 class="documents-modal-title">Upload Documents</h3>
          <button
            #closeBtn
            type="button"
            class="close-btn"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
      </div>

      <div class="modal-body form documents-modal-body">
        <div
          class="custom-dropzone"
          (drop)="onFileDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          [class.dragover]="isDragOver"
          (click)="fileInput.click()"
        >
          <span
            *ngIf="selectedFiles.length > 0"
            (click)="$event.stopPropagation()"
            class="file-list-container"
          >
            <ul class="file-list" (click)="$event.stopPropagation()">
              <li
                class="file"
                *ngFor="let file of selectedFiles; let i = index"
                (click)="$event.stopPropagation()"
              >
                <span>{{ file.name }}</span>
                <button
                  type="button"
                  class="btn btn-primary file-remove-btn"
                  (click)="removeFile(i); $event.stopPropagation()"
                >
                  Remove
                </button>
                <span *ngIf="overwriteWarnings[i]" class="warning-span">
                  This file will overwrite an existing document.
                </span>
              </li>
            </ul>
          </span>
          <input
            type="file"
            multiple
            (change)="onFileSelect($event)"
            class="file-input"
            #fileInput
          />
          <button type="button" class="btn btn-link dropzone-btn">
            <span class="dropzone-text">
              Drag & drop files here or click to select
            </span>
          </button>
        </div>
        <div class="mt-3">
          <label for="comments" class="form-label">Comments</label>
          <textarea
            id="comments"
            class="form-control"
            rows="3"
            [formControl]="commentsControl"
            maxlength="250"
            name="comments"
            placeholder="Add comments (optional)"
          ></textarea>
          <div class="text-end text-muted" style="font-size: 12px;text-align: right;">
            {{ commentsControl.value?.length || 0 }}/250
          </div>
        </div>
      </div>
      <div class="modal-footer documents-modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          (click)="uploadDocuments()"
          [disabled]="selectedFiles.length === 0"
        >
          Upload
        </button>
        <button
          type="button"
          class="btn btn-default md-close"
          data-dismiss="modal"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
